export const FRAME_PADDING = {
  MOBILE: 15,
  TABLET: 20,
  DESKTOP: 30,
};

export const MAX_WIDTH = {
  MOBILE: 480,
  TABLET: 768,
  DESKTOP: 1024,
};

export const COLORS = {
  PRIMARY: '#2ac1bc',
  WHITE: '#ffffff',
  BLACK: '#333333',
};
